export default __webpack_public_path__ + "static/media/TermsOfUse.7ef176c9.md";